/* eslint-disable no-return-assign */
/* eslint-disable no-param-reassign */
const generateReportQuery = ({
  filter, currentPage = 1, perPage = 10, url, exportFormat = 1,
}) => {
  const transformParamsKeys = Object.entries(filter).reduce((prev, current) => ({ ...prev, [current[0].charAt(0).toUpperCase() + current[0].substr(1)]: current[1] }), {})
  const filterParams = Object.entries(transformParamsKeys).reduce((memo, [key, value]) => ((value === '' || value === null) ? memo : (memo[key] = value, memo)), {})
  const params = new URLSearchParams(filterParams).toString()
  let searchURL

  if (!Object.keys(filterParams).length) {
    searchURL = `${url}?FileExportFormat=${exportFormat}&PageNumber=${currentPage}&PageSize=${perPage}`
  } else if (currentPage !== '' || null) {
    searchURL = `${url}?FileExportFormat=${exportFormat}&PageNumber=${currentPage}&PageSize=${perPage}&${params}`
  } else {
    searchURL = `${url}?${params}`
  }
  return searchURL
}

export default generateReportQuery
